import React from "react";
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import axios from "axios";
import formatDatetime from "../utils/formatDateTime.js";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TableData from "../components/table/TableData";
import Dropdown from "../components/dropdowns/Dropdown";
import { DataDropdownStatus } from "../components/dataMockup/DataMockDropdown";
import { DataDropdownPermissionType } from "../components/dataMockup/DataMockDropdown";

function Permission() {
  const navigate = useNavigate();
  const [dataTable, setDatatable] = useState([]);

  const [inputForm, setInputForm] = useState({
    permissionName: "", //ชื่อสิทธิ์การใช้งาน
    activeStatus: 0, //สถานะ
  });

  function setinput(inputname, value) {
    setInputForm((prev) => {
      return {
        ...prev,
        [inputname]: value,
      };
    });
  }

  const [valuefromparent1, setValuefromparent1] = useState("ทั้งหมด");
  const [permissionName, setPermissionName] = useState("");

  const navigateToAddPage = () => {
    navigate("/a&e_infoAccountPayment");
  };

  function ChangesetValuefromparent1(text) {
    setValuefromparent1(text);
  }

  const onChangeInputName = (e) => {
    if (e) {
      setinput("permissionName", e.target.value);
      setPermissionName(e.target.value);
    }
  };
  const [selectedStatus, setSelecteStatus] = useState("");


  const handleStatusChange = (value) => {
    setSelecteStatus(value);
  };

  function resetDropdown() {
    window.location.reload();
  }

  const dataHeader = [
    { label: "ลำดับ" },
    { label: "รหัสสิทธิ์การใช้งาน" },
    { label: "ชื่อสิทธิ์การใช้งาน" },
    { label: "สถานะ" },
    { label: "วันที่สร้าง" },
    { label: "อัปเดตล่าสุด" },
    { label: "เครื่องมือ" },
  ];
  return (
    <>
      <Header parentmenu={"สิทธิ์การใช้งาน"} />
      <Menu 
      parentmenu={"userManagement"}
      activemenu={"infoPermission"} 
      />
      <div className="content-wrapper">
        <div className="container-fluid mt-2 pdb-page">
          <div className="box-headText">
            <Row>
              <Col xs={8} md={9} xl={10} className="d-flex align-items-center">
                <p className="mb-0 font-weight-bold fontReg font-size01">
                  สิทธิ์การใช้งาน
                </p>
              </Col>
              <Col xs={4} md={3} xl={2} className="d-flex justify-content-end">
                <button
                  className="btn-create"
                  onClick={() => navigateToAddPage()}
                >
                  + สร้าง
                </button>
              </Col>
            </Row>
          </div>
          <div className="box-white">
            <i className="fas fa-search colorGreen02"></i>
            <font className="font-weight-bold fontReg font-size01"> ค้นหา</font>
            <div className="bd-line01"></div>
            <Row className="mt-2">
              <Col xs={4} md={3}>
                <label className="fontLight font-size03 colorGray01">
                  ชื่อสิทธิ์การใช้งาน
                </label>
                <input
                  type="text"
                  className="inp01 fontLight font-size03"
                  id="permission_name"
                  placeholder="ชื่อสิทธิ์การใช้งาน"
                  value={permissionName}
                  onChange={onChangeInputName}
                />
              </Col>
              <Col xs={4} md={3}>
                <label className="fontLight font-size03 colorGray01">
                  สถานะ
                </label>
                <Dropdown
                  options={DataDropdownStatus}
                  setinput={setinput}
                  inputname={"activeStatus"}
                  ChangesetValuefromparent={ChangesetValuefromparent1}
                  valuefromparent={valuefromparent1}
                  onChange={handleStatusChange}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={6} className="d-flex justify-content-end">
                <button className="btn-search">
                  <i className="fas fa-search"></i> ค้นหา
                </button>
              </Col>
              <Col xs={6}>
                <button className="btn-reset" onClick={resetDropdown}>
                  <i className="fas fa-undo"></i> เริ่มใหม่
                </button>
              </Col>
            </Row>
          </div>
          <div className="box-white mt-3">
            <i className=" fas fa-table colorGreen02"></i>
            <font className="font-weight-bold fontReg font-size01">
              {" "}
              ตารางแสดง
            </font>
            <div className="bd-line01"></div>
            <TableData
              dataHeader={dataHeader}
              viewUrl={"/view_infoAccountPayment?id="}
              editUrl={"/a&e_infoAccountPayment?id="}
              dataTable={dataTable}
              idName={"payment_info_id"}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Permission;
